// @ts-nocheck
// ====== Supabase client ======
// L'anon key e' pubblica per design: la sicurezza e' garantita dalle policy RLS
// definite sul database. Non e' un segreto da nascondere.
//
// Multi-ambiente:
//   - Build production -> usa env VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY (default = prod)
//   - Build staging    -> stesse env, ma popolate da Cloudflare Pages env "staging"
//   - Fallback hardcoded a produzione (per no-build / file diretti)

import { createClient } from '@supabase/supabase-js';

const PROD_URL = 'https://lofarvmaricvtaxnqgby.supabase.co';
const PROD_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxvZmFydm1hcmljdnRheG5xZ2J5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzNzQ5MDgsImV4cCI6MjA5NDk1MDkwOH0.7qbhMIzIlh7vlLEosjAnol9bXdSmsT5aFeDSPYuOwiQ';

const SUPABASE_URL =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL) || PROD_URL;
const SUPABASE_ANON_KEY =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_ANON_KEY) || PROD_ANON_KEY;

export const sb = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage
  }
});

globalThis.sb = sb;
globalThis.SUPABASE_URL = SUPABASE_URL;
globalThis.SUPABASE_IS_STAGING = SUPABASE_URL.includes('dlimvhmphkjdckacwvaf');

// Badge visibile se sto su staging (per non confondersi con prod)
if (globalThis.SUPABASE_IS_STAGING) {
  document.addEventListener('DOMContentLoaded', () => {
    const badge = document.createElement('div');
    badge.textContent = 'STAGING';
    badge.style.cssText =
      'position:fixed;top:0;left:50%;transform:translateX(-50%);background:#d97706;color:#fff;padding:2px 10px;font-size:11px;font-weight:600;z-index:9999;border-radius:0 0 6px 6px;';
    document.body.appendChild(badge);
  });
}

export {};
